import Handshake from '../../../images/icons/handshake.svg';
import PiggyBank from '../../../images/icons/piggy-bank.svg';
import Scale from '../../../images/icons/scale.svg';

export const bestMortgageValueProps = [
  {
    header: "We cut the lender's biggest expense so we can offer you a better deal",
    text: "A huge portion of the cost of your mortgage goes to pay your loan officer's commission. Lenders pay us less than half of what they typically pay their loan officers, so you'll consistently find better rates and terms in our marketplace.",
    Image: {
      svg: PiggyBank,
      imageName: 'piggy-bank.svg',
      height: 60
    }
  },
  {
    header: 'We make it easy to compare accurate mortgage offers across lenders',
    text: 'Mortgage shopping is a pain. Long applications and annoying hoops to jump through, just to find out the bottom line. Our technology sorts through thousands of options to put your best offers, right up front — including detailed closing costs.',
    Image: {
      svg: Scale,
      imageName: 'scale.svg',
      height: 60
    }
  },
  {
    header: "We're on your side, not the lender's",
    text: "The more you pay in interest and fees, the more profit the lender makes. That’s not how we work. We're paid the same fee by every lender, across every loan, for every customer. We’ve pre-negotiated market beating rates, so you don’t have to haggle to get a great deal.",
    Image: {
      svg: Handshake,
      imageName: 'handshake.svg',
      height: 60
    }
  }
];
